import React, { Component } from 'react';

import { SCREEN_ID_JOIN_SUNROOM_SELECT_MARKETING } from 'client/constants/screenIds';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

import Navbar from 'client/components/Navbar';

import SrLink from 'client/components/SrLink/SrLink';

@withTransitionHook
@withScreenId(SCREEN_ID_JOIN_SUNROOM_SELECT_MARKETING)
@withScrollToTop
class SunroomSelectMarketingPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'About Sunroom Select | Sunroom Rentals',
    section: 'About Sunroom Select',
    // canonical: '/',
    keywords: 'rent, home, austin, tour, apartment, sunroom faq',
    description:
      'Learn about how Sunroom Select saves you money off your home and apartment rentals.',
  });

  render() {
    return (
      <div className="page-sunroom-select-marketing">
        <Navbar
          leftButton={
            <SrLink to="/profile">
              <span className="link back" />
            </SrLink>
          }
          rightButton={
            <SrLink to="/join-sunroom-club">
              <span className="arrowButton go" />
            </SrLink>
          }
        />

        <div className="contentContainer">
          <h1>
            4 Reasons to Join
            <br />
            Sunroom Select
          </h1>

          <div className="dividorLine yellow" />

          <span className="subhead">
            We’ve helped thousands of
            <br />
            renters in Texas.
          </span>

          <div className="mainContent">
            <h2>1. Less fees</h2>
            <p>
              When you apply to any rental here in Texas, the landlord normally will make you pay a
              fee just to apply, even if you don’t get accepted. We don’t think that’s right,
              renters like yourself deserve better. If you join Sunroom select today,{' '}
              <span className="bold color-green">Sunroom will pay for half of that fee</span>. So,
              when you apply through Sunroom, you’re guaranteed to pay less fees than any other
              site.
            </p>
            <div className="graphic coin" />

            <h2>2. Apply online</h2>
            <p>
              It’s that easy, you can land any rental by just tapping some buttons on your phone.
              Sunroom has made it easy to apply to any rental here in Texas.
              <span className="bold color-green">
                {' Without us, you’d be filling out paper forms like you do at the DMV. '}
              </span>
              Use Sunroom, and everything will be easier.
            </p>
            <div className="graphic phone" />

            <h2>3. Stress-free home search</h2>
            <p>
              We make it easy to see rentals anytime with our agents. You can see homes on the
              weekends and on weeknights, after you get home from work or school.
              <span className="bold color-green">
                {' No more waiting on flaky agents or landlords! '}
              </span>
              That’s what we call VIP access with Sunroom Select.
            </p>
            <div className="graphic celebrate" />

            <h2>4. Get a dedicated rental expert in Texas</h2>
            <p>
              We've partnered with thousands of agents to bring you
              <span className="italics">{' the best '}</span>
              rentals in Texas. In competitive markets like Texas, over 50% of renters get rejected
              when they apply for a home.
              <span className="bold color-green">
                {' Sunroom experts review your application so you land the ' +
                  "place that's right for you!"}
              </span>
            </p>
            <div className="graphic expert" />
          </div>

          <div className="bottomCta">
            <span className="headline">Join Sunroom Select and start saving now</span>
            <SrLink to="/join-sunroom-club">
              <span className="button green">join now</span>
            </SrLink>
          </div>

          <div className="footer">
            <span>
              Made with <span className="color-red">❤</span> in Austin, TX.
            </span>
          </div>
        </div>
      </div>
    );
  }
}

SunroomSelectMarketingPage.displayName = 'SunroomSelectMarketingPage';

export default SunroomSelectMarketingPage;
